import { Component, OnInit } from '@angular/core';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
  selector: 'app-shared-plan-explanation',
  templateUrl: './shared-plan-explanation.component.html',
  styleUrls: ['./shared-plan-explanation.component.scss']
})
export class SharedPlanExplanationComponent implements OnInit {

  constructor(public themeService: ThemeService) { }

  ngOnInit() {
  }

}
